import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { MINIMUM_STALE_TIME } from "../../providers/APQueryProvider";
import { User } from "../../types/User";

export const getMyUser = (employerId?: string) => {
  const { fetchWithAuth } = useApi();
  const queryParams = employerId ? { EmployerID: employerId } : undefined;

  return useQuery({
    queryKey: ["user"],
    queryFn: (): Promise<User> => {
      return fetchWithAuth<User>("getMyUser", undefined, { queryParams });
    },
    staleTime: MINIMUM_STALE_TIME,
  });
};
